import { Gtm } from '../gtmClass';

export class ReactNativeGtm extends Gtm {
  /**  앱 설치 클릭시 */
  click_app_install() {
    this.track('click_app_install', { path: this.path });
  }

  /** 웹→앱 설치 유도 모달 노출시 */
  view_app_install_banner() {
    this.track('view_app_install_banner', { path: this.path });
  }

  /**
   * 앱 전용 쿠폰 발급(쿠폰 받기) 클릭시
   *
   * coupon_id는 문자로 보낸다. Braze가 이 이벤트의 coupon_id를 문자로 등록해 두어
   * 숫자로 보내면 CRM 캠페인의 쿠폰 조건에 걸리지 않는다(웹 발급 경로와 동일한 형식).
   */
  click_download_coupon(props: { coupon_id: number | null }) {
    this.track('click_download_coupon', {
      coupon_id: props.coupon_id === null ? null : String(props.coupon_id),
      path: this.path,
    });
  }

  /** 앱 오픈시 */
  open_app(props: { deep_link: string | null }) {
    try {
      const pathname = props.deep_link
        ? new URL(props.deep_link).pathname
        : null;

      const deep_link = pathname ? this.getNormalizedPath(pathname) : null;

      this.track('open_app', { deep_link });
    } catch (error) {
      console.error(error);
    }
  }
}
